import { ReactElement } from 'react';
import { Button } from '@Components/Button';
import { Size } from '@Components/designConstants';
import { AdminAction, AdminActionType } from './admin-constants';

interface AdminActionButtonsProps {
  workingAction: AdminActionType | null;
  onUpdateTrafficClick: () => void;
  onDownloadTapesClick: () => void;
  onClearSheetsClick: () => void;
  onClearCompaniesClick: () => void;
  onDownloadAllClick: () => void;
}

export const AdminActionButtons = ({
  workingAction,
  onUpdateTrafficClick,
  onDownloadTapesClick,
  onClearSheetsClick,
  onClearCompaniesClick,
  onDownloadAllClick
}: AdminActionButtonsProps): ReactElement => {
  // Disables the rest while one action is working, so mutations can't overlap.
  const buttonState = (action: AdminActionType) => ({
    loading: workingAction === action,
    disabled: workingAction !== null && workingAction !== action
  });

  return (
    <div className='admin-page-buttons'>
      <Button
        size={Size.LG}
        {...buttonState(AdminAction.UPDATE_TRAFFIC)}
        onClick={onUpdateTrafficClick}
      >
        Update Traffic from Extreme Reach
      </Button>
      <Button
        size={Size.LG}
        {...buttonState(AdminAction.DOWNLOAD_TAPES)}
        onClick={onDownloadTapesClick}
      >
        Download Linear Tapes Report
      </Button>
      <Button
        size={Size.LG}
        {...buttonState(AdminAction.CLEAR_SHEETS)}
        onClick={onClearSheetsClick}
      >
        Clear Sheets
      </Button>
      <Button
        size={Size.LG}
        {...buttonState(AdminAction.CLEAR_COMPANIES)}
        onClick={onClearCompaniesClick}
      >
        Clear Companies and Users
      </Button>
      <Button size={Size.LG} disabled={workingAction !== null} onClick={onDownloadAllClick}>
        Download All Reports
      </Button>
    </div>
  );
};
